import angular from 'angular';
import ngRedux from 'ng-redux';
import reducers from './../reducers/reducers';
import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import 'angular-animate';
import 'angular-ui-router';
import 'angular-permission';
import 'satellizer';
import 'restangular';
import Localization from './localization/localization';
import Resources from '../resources/resources';
import AngularticsConfig from './angulartics'
import ApiConfig from './api.config';
import FormlyConfig from './formly.config';
import PermissionConfig from './permission.config';
import FeatureFlagsConfig from './featureFlags/featureFlags.config';
import { CacheController } from '../common/appLifeCycle/emptyCache.js';
import { MirrorController } from '../common/appLifeCycle/stateMirror.js';

export const creativesPendingVariationStorageKey = 'creativesPendingVariationId';

export default angular.module('app.configs', [
  Localization.name,
  Resources.name,
  AngularticsConfig.name,
  ApiConfig.name,
  FormlyConfig.name,
  PermissionConfig.name,
  FeatureFlagsConfig.name,
  ngRedux,
  'feature-flags',
  'ngAnimate',
  'ui.router',
  'permission',
  'satellizer',
  'restangular'
])
  .run(function($locale, featureFlags, defaultFeatureFlags){

    moment.defaultFormat = 'D.MM.YYYY';
    $locale.DATETIME_FORMATS['mediumDate'] = 'd.MM.yyyy';
    $locale.DATETIME_FORMATS['short'] = "d MMM`yy";
    featureFlags.set(defaultFeatureFlags);
  })
  .config(($ngReduxProvider) => {
    let rootReducer = reducers;
    $ngReduxProvider.createStoreWith(rootReducer, [thunk]);
  })
  .config(function($stateProvider){
    $stateProvider
      .state('app', {
        abstract: true,
        url: '',
        template: '<ui-view/>'
      })
      .state('emptyCache', {
        url: '/ec',
        resolve: {
          previousState: [
            "$state",
            function ($state) {
              return {
                name: $state.current.name,
                params: $state.params,
                url: $state.href($state.current.name, $state.params)
              };
            }
          ]
        },
        controller: CacheController
      })
      .state('mirror', {
        url: '/mirror',
        params: { extraParam: null },
        resolve: {
          previousState: [
            "$state",
            function ($state) {
              return {
                name: $state.current.name,
                params: $state.params,
                url: $state.href($state.current.name, $state.params)
              };
            }
          ]
        },
        controller: MirrorController
      })
  })
  .config(function($urlRouterProvider){
    $urlRouterProvider.rule(function($injector, $location) {
      const match = $location.path().match(/^(.*?)#(\d+(?:-\d+)?)$/);
      if (match) {
        const basePath = match[1];
        if (!/\/creatives(?:\/|$)/.test(basePath)) {
          return;
        }
        const $window = $injector.get('$window');
        try {
          $window.sessionStorage.setItem(creativesPendingVariationStorageKey, match[2]);
        } catch (e) {
          $window.__creativesPendingVariationId = match[2];
        }
        return match[1];
      }
    });
  })
  .config(function($animateProvider){
    $animateProvider.classNameFilter(/^((?!(formly-field|c-chart|c-main|no-animate)).)*$/);
  })


/** WEBPACK FOOTER **
 ** ./src/configs/configs.js
 **/